import EmojiPicker from "emoji-picker-react";
import { FormEvent, useState } from "react";
import { Form, Input } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { replyByUserAsync, sendMessageAsync } from "../../../../../ReduxToolkit/Reducers/ChatSlice";
import { TypeMessageHere } from "../../../../../Utils/Constants";
import ChatDropMenu from "./ChatDropMenu";

const SendMessage = () => {
  const [messageInput, setMessageInput] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const { chats, selectedUser, currentUser } = useAppSelector((state) => state.chat);

  const dispatch = useAppDispatch();
  const addEmoji = (emoji: string) => {
    const text = `${messageInput}${emoji}`;
    setShowEmojiPicker(false);
    setMessageInput(text);
  };
  const handleMessageChange = (message: string) => {
    setMessageInput(message);
  };

  const handleMessagePress = () => {
    var container = document.getElementsByClassName("messenger-chat")[0];
    setTimeout(function () {
      container?.scrollBy({ top: 200, behavior: "smooth" });
    }, 310);
    let currentUserId = currentUser?.id;
    let selectedUserId = selectedUser?.id;
    let selectedUserName = selectedUser?.name;
    if (messageInput.length > 0) {
      dispatch(sendMessageAsync({ currentUserId, selectedUserId, messageInput, chats }));
      setMessageInput("");
      setTimeout(() => {
        const replyMessage = "Hey This is " + selectedUserName + ", Sorry I'm busy right now, I will text you later";
        dispatch(replyByUserAsync({ currentUserId, selectedUserId, replyMessage, chats }));
      }, 2000);
    }
  };
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleMessagePress();
  };
  return (
    <Form className="msger-inputarea" onSubmit={(e) => handleSubmit(e)}>
      <ChatDropMenu />
      <Input className="msger-input two uk-textarea" type="text" placeholder={TypeMessageHere} value={messageInput} onChange={(e) => handleMessageChange(e.target.value)} />
      <div>{showEmojiPicker ? <EmojiPicker onEmojiClick={({ emoji }) => addEmoji(emoji)} /> : null}</div>
      <div className="open-emoji">
        <div className="second-btn uk-button" onClick={() => setShowEmojiPicker(!showEmojiPicker)} />
      </div>
      <Btn color="primary" className="msger-send-btn" onClick={handleMessagePress}>
        <i className="fa fa-location-arrow" />
      </Btn>
    </Form>
  );
};

export default SendMessage;
